export const VARIATION = [
  'benefit',
  'informational',
]
